import React from "react";
import { studentcardProps } from "./studentcard-interface";
import { Avatar, Dropdown, MenuProps } from "antd";

const Studentcard = ({
  item,
  index,
  showOptions,
  viewStudent,
  offRankingNumber,
  optionsWithoutAssign,
	showTotalFP
}: studentcardProps) => {
  const items: MenuProps["items"] = [
    {
      key: `${item?._id}-open`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/students}`}
          onClick={(e) => {
            e.preventDefault();
            if (viewStudent !== undefined) {
              viewStudent(item);
            }
          }}
        >
          View
        </a>
      ),
    },
    {
      key: `${item?._id}-send-message`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/students}`}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Send Message
        </a>
      ),
    },
  ];

  const itemsWithAssign: MenuProps["items"] = [
    {
      key: `${item?._id}-open`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/students}`}
          onClick={(e) => {
            e.preventDefault();
            if (viewStudent !== undefined) {
              viewStudent(item);
            }
          }}
        >
          View
        </a>
      ),
    },
    {
      key: `${item?._id}-send-message`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/students}`}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Send Message
        </a>
      ),
    },
    {
      key: `${item?._id}-assign-tutorials`,
      label: (
        <a
          rel="noopener noreferrer"
          href={`/teacher/students}`}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Assign Tutorials
        </a>
      ),
    },
  ];

  return (
    <div>
      <div
        key={`fpt-${item.id}`}
        className={`mb-0 flex items-center justify-between p-4 hover:rounded-[10px] hover:bg-appcolororangefaint  `}
      >
        <div className="flex items-center">
          {offRankingNumber ? null : (
            <p className="mr-2 rounded-[7px] bg-appcolorpurplefour px-[0.6rem] py-[0.2rem] text-appcolorwhite">
              {index + 1}
            </p>
          )}

          <div className="flex items-center">
            <Avatar
              src={`${
                item?.userAvatarURL === undefined
                  ? "/img/vectors/userfemale.svg"
                  : item?.userAvatarURL === ""
                  ? "/img/vectors/userfemale.svg"
                  : item?.userAvatarURL
              }`}
              style={{
                border: "2px solid #FBE0FF",
                borderRadius: "50%",
                width: "3rem",
                height: "3rem",
              }}
            />

            <div className="ml-3">
              <p className="mb-1 text-base font-semibold text-appcolorblack">
                {item.firstName}
              </p>
              <p className="text-base font-semibold  text-appcolorblack opacity-[0.5]">
                {item.lastName}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center">
          {showTotalFP ? (
            <div className="mr-4">
              <p className="mb-1 text-base font-semibold text-appcolorblack">
                {item?.wallet?.funPoints ?? 0} FP
              </p> 
            </div>
          ) : null}

          {showOptions ? (
            <Dropdown
              menu={{ items: optionsWithoutAssign ? items : itemsWithAssign }}
              placement="bottomRight"
            >
              <img
                src="/img/vectors/more.svg"
                alt="more"
                className="w-8 h-5 cursor-pointer"
              />
            </Dropdown>
          ) : null}
        </div>
      </div>
    </div>
  );
};

Studentcard.defaultProps = {
  showOptions: false,
  offRankingNumber: false,
  optionsWithoutAssign: false,
  showTotalFP: false,
};

export default Studentcard;
